export default __webpack_public_path__ + "static/media/left-arrow.3dad4ca7.svg";